export default __webpack_public_path__ + "static/media/card_middle.e03d2a99.png";